module.exports = __webpack_public_path__ + "media/images/about-sec-69431c25024bcf9a4412509d0aed6ad6.jpg";